import React from 'react';
import { Navigate } from 'react-router-dom';

const ALLOWED_USERS = [
  'charles@dukeleads.com',
  'aduke@morganhill.co.uk',
  'jrosenzweig@morganhill.co.uk',
  'rmorton@morganhill.co.uk',
];

const OverviewRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const username = localStorage.getItem('username');

  if (!token) {
    return <Navigate to='/login' replace />;
  }

  if (!ALLOWED_USERS.includes(username)) {
    return <Navigate to='/dashboard' replace />;
  }

  return children;
};
export default OverviewRoute;
